import { optionType } from "../../../components/organism/CustomSelect";

function insuranceCompanySelectionSideEffect(
 option: optionType,
 setFieldValue: Function,
 setFieldTouched: Function
) {
 if (option.value == 19) return;

 setFieldValue("billingInfo.insuranceCompanyName", option.label, true);
 setTimeout(() => {
  setFieldTouched("billingInfo.insuranceCompanyName", true);
 }, 500);
}
export default insuranceCompanySelectionSideEffect;
